import i18n from '../../translation/config';

enum OrderStatusType {
  CREATED_STATUS = 1,
  PAYMENT_ACCEPTED_STATUS = 2,
  TO_DELIVER_STATUS = 3,
  PREPARING_STATUS = 4,
  DELIVERING_STATUS = 5,
  DELIVERED_STATUS = 6,
  INCOMPLETED_STATUS = 7,
}

export const getStatusName = (orderStatusType: OrderStatusType): string => {
  switch (orderStatusType) {
    case OrderStatusType.CREATED_STATUS:
      return 'Pendiente';
    case OrderStatusType.PAYMENT_ACCEPTED_STATUS:
      return 'Pendiente';
    case OrderStatusType.TO_DELIVER_STATUS:
      return 'Pendiente';
    case OrderStatusType.PREPARING_STATUS:
      return 'En Proceso';
    case OrderStatusType.DELIVERING_STATUS:
      return 'Por Entregar';
    case OrderStatusType.INCOMPLETED_STATUS:
      return 'Cancelado';
    default:
      return '';
  }
};

export const getStatusId = (orderStatusName: string): number => {
  switch (orderStatusName) {
    case 'Pendiente':
      return OrderStatusType.TO_DELIVER_STATUS;
    case 'En Proceso':
      return OrderStatusType.PREPARING_STATUS;
    case 'Por Entregar':
      return OrderStatusType.DELIVERING_STATUS;
    case 'Entregado':
      return OrderStatusType.DELIVERED_STATUS;
    case 'Cancelado':
      return OrderStatusType.INCOMPLETED_STATUS;
    default:
      return 0;
  }
};

export const getTranslatedStatus = (orderStatusName: string): string => {
  switch (orderStatusName) {
    case 'Pendiente':
      return i18n.t('pending');
    case 'En Proceso':
      return i18n.t('in-proccess');
    case 'Por Entregar':
      return i18n.t('to-deliver');
    case 'Entregado':
      return i18n.t('delivered');
    case 'Cancelado':
      return i18n.t('canceled');
    default:
      return '';
  }
};

export const getOrderColorByStatus = (orderStatusId: number): string => {
  switch (orderStatusId) {
    case OrderStatusType.CREATED_STATUS:
      return '#D70B0B';
    case OrderStatusType.PAYMENT_ACCEPTED_STATUS:
      return '#D70B0B';
    case OrderStatusType.TO_DELIVER_STATUS:
      return '#D70B0B';
    case OrderStatusType.PREPARING_STATUS:
      return '#FF8A00';
    case OrderStatusType.DELIVERING_STATUS:
      return '#0D9E00';
    case OrderStatusType.DELIVERED_STATUS:
      return '#0AFF4F';
    default:
      return 'Unknown';
  }
};

export default OrderStatusType;
